import { FunctionComponent, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import MarketingContainer from 'components/GlobalStyles/Marketing/Container'
import Text from 'components/GlobalStyles/Text'
import RoundedButton from 'components/RoundedButton'
import Spacer from 'components/Spacer'

const Container = styled(MarketingContainer)`
  background-color: ${props => props.theme.colors.grey24};
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    background-color: ${props => props.theme.colors.transparent};
  }
`

const GreyBackground = styled.div`
  position: absolute;
  background-color: ${props => props.theme.colors.grey24};
  width: 100%;
  left: 0;
  margin-top: 0;
  z-index: -1;

  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    height: 430px;
    margin-top: 16px;
  }

  /* apply different css style rule on safari browser only to fix alignment issue */
  @media not all and (min-resolution: 0.001dpcm) {
    @supports (-webkit-appearance: none) {
      @media (min-width: ${props => props.theme.metrics.tablet}px) {
        margin-top: 8px;
      }
    }
  }
`

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    height: 100%;
    flex-direction: row;
  }
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    height: 100%;
  }
`

const Header = styled.div`
  font-size: 36px;
  font-weight: 800;
  color: ${props => props.theme.colors.grey27};
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    font-size: 44px;
  }
`

const ImageContainer = styled.div``

const ScreenText = styled.div`
  font-size: 40px;
  line-height: 54px;
  color: ${props => props.theme.colors.white};
  width: 320px;
  padding: 60px 60px 0 60px;
  background: top / contain
    url(${process.env.CDN_BASE_URL}/q_auto,w_500/amazon/assets/pricing-plan-iphone-screen.png)
    no-repeat;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    width: 360px;
    padding: 100px 80px 0 80px;
    transform: scale(1.05);
  }
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    justify-content: flex-start;
  }
`

const Strong = styled.span`
  font-weight: 900;
`

const PricingPlanA: FunctionComponent = () => {
  const theme = useContext(ThemeContext)
  return (
    <Container>
      <LayoutContainer>
        <GreyBackground />
        <ContentContainer>
          <TextContainer>
            <Spacer
              size={32}
              hideTablet
              hideDesktop
            />
            <Header>Everything you need...nothing you don&apos;t</Header>
            <Spacer size={24} />
            <Text
              color={theme.colors.grey23}
              fontSize={20}
              lineHeight="27px"
              paragraph
            >
              3 pricing plans. Always flat fees. Add-ons to get you the help you need. Zero
              complications. Plans start at just $599.
            </Text>
          </TextContainer>
          <Spacer
            size={48}
            tabletSize={32}
            responsiveSize={24}
          />
          <ButtonContainer>
            <RoundedButton
              text="View Pricing Plans"
              href="/pricing"
              background={theme.colors.blue4}
              hoverBackground={theme.colors.blue9}
              color={theme.colors.white}
              boxShadow={`0px 12px 16px ${theme.colors.transparentBlue4Alpha25}`}
              fontSize={12}
              radius={50}
              height={44}
              width={240}
            />
          </ButtonContainer>
        </ContentContainer>
        <Spacer size={36} />
        <ImageContainer>
          <ScreenText>
            Low
            <br />
            flat fees
            <br />
            starting at only
            <br />
            <Strong>$599</Strong>
            .
            <Spacer
              size={50}
              responsiveSize={38}
            />
          </ScreenText>
        </ImageContainer>
      </LayoutContainer>
    </Container>
  )
}

export default PricingPlanA
